import * as dConst from "../actions/messageConst";
import axios from "axios";

const state = {
  messageApi: (process.env.VUE_APP_USTAGE_API || "http://localhost:3000/api") + "/Messages",
  dialogApi: (process.env.VUE_APP_USTAGE_API || "http://localhost:3000/api") + "/Dialogs",
  status: {}
};

for(let x in dConst) {
  state.status[x] = false
}

const getters = {
  isDialogGetList: state => state.status[dConst.DIALOG_GET_LIST],
  isDialogDelete: state => state.status[dConst.DIALOG_DELETE],
  isMessageGetHistory: state => state.status[dConst.MESSAGE_GET_HISTORY],
  isMessageAdd: state => state.status[dConst.MESSAGE_ADD],
}

const actions = {
  [dConst.DIALOG_ADD]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      commit(dConst.DIALOG_ADD);
      axios
        .post(state.dialogApi + '/createDialog', {id: data.dialogWithId})
        .then(res => {
          commit(dConst.DIALOG_ADD_SUCCESS);
          resolve(res.data);
        })
        .catch(err => {
          commit(dConst.DIALOG_ADD_ERROR);
          reject(err);
        });
    })
  },
  [dConst.DIALOG_GET_LIST]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(dConst.DIALOG_GET_LIST);
      axios
        .get(state.dialogApi + '/getList')
        .then(res => {
          commit(dConst.DIALOG_GET_LIST_SUCCESS);
          resolve(res.data);
        })
        .catch(err => {
          commit(dConst.DIALOG_GET_LIST_ERROR);
          reject(err);
        });
    })
  },
  [dConst.DIALOG_DELETE]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      commit(dConst.DIALOG_DELETE);
      axios
        .put(state.dialogApi + '/deleteDialog', {id: data.id})
        .then(res => {
          commit(dConst.DIALOG_DELETE_SUCCESS);
          resolve(res);
        })
        .catch(err => {
          commit(dConst.DIALOG_DELETE_ERROR);
          reject(err);
        });
    })
  },
  [dConst.MESSAGE_GET_HISTORY]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      commit(dConst.MESSAGE_GET_HISTORY);
      axios
      .get(state.messageApi + '/getHistory', {params: {id: data.id}})
      .then(res => {
        commit(dConst.MESSAGE_GET_HISTORY_SUCCESS);
        resolve(res.data);
      })
      .catch(err => {
        commit(dConst.MESSAGE_GET_HISTORY_ERROR);
        reject(err);
      });
    })
  },
  [dConst.MESSAGE_ADD]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      commit(dConst.MESSAGE_ADD);
      axios
        .post(state.messageApi + '/send', {message: data})
        .then(res => {
          commit(dConst.MESSAGE_ADD_SUCCESS);
          resolve(res.data);
        })
        .catch(err => {
          commit(dConst.MESSAGE_ADD_ERROR);
          reject(err);
        });
    })
  },
};

const mutations = {
  [dConst.DIALOG_ADD]: state => {
    state.status[dConst.DIALOG_ADD_SUCCESS] = false
    state.status[dConst.DIALOG_ADD_ERROR] = false
    state.status[dConst.DIALOG_ADD] = true
  },
  [dConst.DIALOG_ADD_SUCCESS]: state => {
    state.status[dConst.DIALOG_ADD] = false
    state.status[dConst.DIALOG_ADD_SUCCESS] = true
  },
  [dConst.DIALOG_ADD_ERROR]: state => {
    state.status[dConst.DIALOG_ADD] = false
    state.status[dConst.DIALOG_ADD_ERROR] = true
  },

  [dConst.MESSAGE_ADD]: state => {
    state.status[dConst.MESSAGE_ADD_SUCCESS] = false
    state.status[dConst.MESSAGE_ADD_ERROR] = false
    state.status[dConst.MESSAGE_ADD] = true
  },
  [dConst.MESSAGE_ADD_SUCCESS]: state => {
    state.status[dConst.MESSAGE_ADD] = false
    state.status[dConst.MESSAGE_ADD_SUCCESS] = true
  },
  [dConst.MESSAGE_ADD_ERROR]: state => {
    state.status[dConst.MESSAGE_ADD] = false
    state.status[dConst.MESSAGE_ADD_ERROR] = true
  },

  [dConst.DIALOG_GET_LIST]: state => {
    state.status[dConst.DIALOG_GET_LIST_SUCCESS] = false
    state.status[dConst.DIALOG_GET_LIST_ERROR] = false
    state.status[dConst.DIALOG_GET_LIST] = true
  },
  [dConst.DIALOG_GET_LIST_SUCCESS]: state => {
    state.status[dConst.DIALOG_GET_LIST] = false
    state.status[dConst.DIALOG_GET_LIST_SUCCESS] = true
  },
  [dConst.DIALOG_GET_LIST_ERROR]: state => {
    state.status[dConst.DIALOG_GET_LIST] = false
    state.status[dConst.DIALOG_GET_LIST_ERROR] = true
  },

  [dConst.MESSAGE_GET_HISTORY]: state => {
    state.status[dConst.MESSAGE_GET_HISTORY_SUCCESS] = false
    state.status[dConst.MESSAGE_GET_HISTORY_ERROR] = false
    state.status[dConst.MESSAGE_GET_HISTORY] = true
  },
  [dConst.MESSAGE_GET_HISTORY_SUCCESS]: state => {
    state.status[dConst.MESSAGE_GET_HISTORY] = false
    state.status[dConst.MESSAGE_GET_HISTORY_SUCCESS] = true
  },
  [dConst.MESSAGE_GET_HISTORY_ERROR]: state => {
    state.status[dConst.MESSAGE_GET_HISTORY] = false
    state.status[dConst.MESSAGE_GET_HISTORY_ERROR] = true
  },

  [dConst.DIALOG_DELETE]: state => {
    state.status[dConst.DIALOG_DELETE_SUCCESS] = false
    state.status[dConst.DIALOG_DELETE_ERROR] = false
    state.status[dConst.DIALOG_DELETE] = true
  },
  [dConst.DIALOG_DELETE_SUCCESS]: state => {
    state.status[dConst.DIALOG_DELETE] = false
    state.status[dConst.DIALOG_DELETE_SUCCESS] = true
  },
  [dConst.DIALOG_DELETE_ERROR]: state => {
    state.status[dConst.DIALOG_DELETE] = false
    state.status[dConst.DIALOG_DELETE_ERROR] = true
  },
  
};

export default {
  state,
  getters,
  actions,
  mutations,
}